import { useMemo } from 'react';
import { useContent } from 'src/contexts/ContentContext';
import { PosSelect, PosSelectProps } from 'src/core/POS/PosSelect';
import { useConsigneeAccountInfo } from 'src/hooks/api/useConsigneeAccountInfo';
import { EMPTY_GUID } from 'src/utils/constants/constants';
import { ContentId } from 'src/utils/constants/contentId';

export const ConsigneeSellerAccountSelector = ({
  placeholderText,
  unchangedText,
  ...props
}: Omit<PosSelectProps, 'valueOptionsContent'> & {
  allowUnchanged?: boolean;
  unchangedText?: string;
}) => {
  const { data: consigneeAccountInfo } = useConsigneeAccountInfo();
  const unchanged = useContent(ContentId.DontChange);

  const allActiveConsigneeOptions = useMemo(() => {
    if (!consigneeAccountInfo) return {};

    const results = {} as Record<string, string>;
    if (props.allowUnchanged) {
      results[EMPTY_GUID] = unchangedText ?? unchanged;
    }

    Object.values(consigneeAccountInfo).reduce((r, cur) => {
      r[cur.id] = cur.accountName;
      return r;
    }, results);

    return results;
  }, [consigneeAccountInfo, props.allowUnchanged, unchangedText, unchanged]);

  return (
    <PosSelect
      {...props}
      searchable={
        props.searchable != null
          ? props.searchable
          : Object.values(allActiveConsigneeOptions).length > 10
      }
      sortFn={(sellerIdA, sellerIdB) => {
        if (sellerIdA === EMPTY_GUID) {
          return -1;
        }
        if (sellerIdB === EMPTY_GUID) {
          return 1;
        }

        return 0;
      }}
      loading={consigneeAccountInfo == null}
      placeholderText={placeholderText ?? ContentId.Everyone}
      valueOptionsContent={allActiveConsigneeOptions}
      sortBy="key"
    />
  );
};
